import React, { createContext, useContext } from 'react'

/**
 * Explicit feature-flag overrides for a subtree, keyed by the flag's
 * kebab-case value (what call sites pass via FeatureFlagKeys.X). A flag
 * present here wins over PostHog; absent flags resolve normally.
 *
 * Built for the BI cardKey shells: on the BI surface the hand-built analytics
 * dashboards must ALWAYS render their Cube-backed widgets — the legacy
 * fallback tiles are staged-rollout artifacts of /analytics and query
 * unregistered cubes, which the BI allowlist forbids.
 */
export type FeatureFlagOverrides = Readonly<Record<string, boolean>>

const FeatureFlagOverridesContext = createContext<FeatureFlagOverrides>({})

export const FeatureFlagOverridesProvider: React.FC<{ overrides: FeatureFlagOverrides }> = ({
  overrides,
  children,
}) => (
  <FeatureFlagOverridesContext.Provider value={overrides}>
    {children}
  </FeatureFlagOverridesContext.Provider>
)

export const useFeatureFlagOverride = (flagKey: string): boolean | undefined =>
  useContext(FeatureFlagOverridesContext)[flagKey]
